<template>
	<div>
		<p v-if="label">{{label}}</p>
		<div class="emoji-container">
			<div v-for="emoji in emojis" :key="emoji.id" @click="selectEmoji(emoji)">
				<base-icon :src="emoji.img" alt="emoji" :color="emoji.color" :width="size" :height="size"/>
			</div>
		</div>
	</div>
</template>

<script>
import wrapperMixin from '@/mixins/wrapper.mixin'
import clinicHistoryVariableColorsMixin from '@/mixins/clinicHistoryVariableColors.mixin'

function getEmojiSrc (fileName) {
	const ROOT_RELATIVE_PATH = '/static-appopensalud/img/icons/emojis/'
	return ROOT_RELATIVE_PATH + fileName
}

const EMOJI_SIZE = 75
const EMOJI_SIZE_XS = 40

export default {
	mixins: [wrapperMixin(Number), clinicHistoryVariableColorsMixin],
	props: {
		label: String
	},
	computed: {
		emojis () {
			return [
				{ value: 0, img: getEmojiSrc('emoji-very-sad.svg'), color: this.minColor },
				{ value: 3, img: getEmojiSrc('emoji-sad.svg'), color: this.firstQuartileColor },
				{ value: 5, img: getEmojiSrc('emoji-no-feelings.svg'), color: this.mediumColor },
				{ value: 8, img: getEmojiSrc('emoji-semi-happy.svg'), color: this.thirdQuartileColor },
				{ value: 10, img: getEmojiSrc('emoji-happy.svg'), color: this.maxColor }
			]
		},
		size () {
			return this.$uiHelpers.isMobile ? EMOJI_SIZE_XS : EMOJI_SIZE
		}
	},
	methods: {
		selectEmoji (emoji) {
			// Emit the value if it is the first time and is the same than default
			if (this.localValue === emoji.value) {
				this.$emit('change', emoji.value)
			}
			this.localValue = emoji.value
		}
	}
}
</script>

<style lang="scss">
.emoji-container {
	display: flex;
	margin: 1rem 0;
	justify-content: center;
}

.emoji-container div {
	margin: 0 2rem;

	@include mobile {
		margin: 0 .5rem;
	}

	cursor: pointer;
	transition: transform 0.3s;

	&:hover {
		transform: scale(1.1);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/base/forms/EmojiInput.vue